import { render, staticRenderFns } from "./InvoiceMigration.vue?vue&type=template&id=5fef7575&scoped=true"
import script from "./InvoiceMigration.vue?vue&type=script&lang=js"
export * from "./InvoiceMigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef7575",
  null
  
)

export default component.exports